export class DistributionListControllerModel {
    $translate;
    $mdDialog;
    log;
    webClientService;
    receiverType = 'distributionList';
    subject;
    isLoading = false;
    members;
    name;
    addContactPlaceholder;
    distributionList;
    mode;
    onRemovedCallback;
    constructor($translate, $mdDialog, logService, webClientService, mode, distributionList) {
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.log = logService.getLogger('DistributionList-CM');
        if (distributionList === undefined) {
            if (mode !== "new") {
                throw new Error('DistributionListControllerModel: Distribution list ' +
                    'may not be undefined for mode ' + mode);
            }
        }
        else {
            this.distributionList = distributionList;
        }
        this.mode = mode;
        this.webClientService = webClientService;
        this.addContactPlaceholder = $translate.instant('messenger.DISTRIBUTION_LIST_SELECT_MEMBERS');
        switch (this.getMode()) {
            case "edit":
                this.subject = $translate.instant('messenger.EDIT_RECEIVER');
                this.name = this.distributionList.displayName;
                this.members = this.distributionList.members;
                break;
            case "view":
            case "chat":
                this.subject = this.distributionList.displayName;
                this.members = this.distributionList.members;
                break;
            case "new":
                this.subject = $translate.instant('messenger.CREATE_DISTRIBUTION_LIST');
                this.members = [];
                break;
            default:
                this.log.error('Invalid controller model mode: ', this.getMode());
        }
    }
    setOnRemoved(callback) {
        this.onRemovedCallback = callback;
    }
    getMode() {
        return this.mode;
    }
    isValid() {
        return this.members.filter((identity) => {
            return identity !== this.webClientService.me.id;
        }).length > 0;
    }
    canChat() {
        return true;
    }
    canEdit() {
        return true;
    }
    canClean() {
        return true;
    }
    clean(ev) {
        const confirm = this.$mdDialog.confirm()
            .title(this.$translate.instant('messenger.DELETE_THREAD'))
            .textContent(this.$translate.instant('messenger.DELETE_THREAD_MESSAGE', { count: 1 }))
            .targetEvent(ev)
            .ok(this.$translate.instant('common.YES'))
            .cancel(this.$translate.instant('common.CANCEL'));
        this.$mdDialog.show(confirm).then(() => {
            this.reallyClean();
        }, () => {
            this.log.debug('Clean cancelled');
        });
    }
    reallyClean() {
        if (!this.distributionList) {
            this.log.error('reallyClean: Distribution list is null');
            return;
        }
        if (!this.canClean()) {
            this.log.error('Not allowed to clean this distribution list');
            return;
        }
        this.isLoading = true;
        this.webClientService.cleanReceiverConversation(this.distributionList)
            .then(() => {
            this.isLoading = false;
        })
            .catch((error) => {
            this.log.error(`Cleaning receiver conversation failed: ${error}`);
            this.isLoading = false;
        });
    }
    canShowQr() {
        return false;
    }
    delete(ev) {
        const confirm = this.$mdDialog.confirm()
            .title(this.$translate.instant('messenger.DISTRIBUTION_LIST_DELETE'))
            .textContent(this.$translate.instant('messenger.DISTRIBUTION_LIST_DELETE_REALLY'))
            .targetEvent(ev)
            .ok(this.$translate.instant('common.OK'))
            .cancel(this.$translate.instant('common.CANCEL'));
        this.$mdDialog.show(confirm).then(() => {
            this.reallyDelete();
        }, () => {
            this.log.debug('Delete cancelled');
        });
    }
    reallyDelete() {
        if (!this.distributionList) {
            this.log.error('reallyDelete: Distribution list is null');
            return;
        }
        if (!this.distributionList.access.canDelete) {
            this.log.error('Not allowed to delete this distribution list');
            return;
        }
        this.isLoading = true;
        this.webClientService.deleteDistributionList(this.distributionList).then(() => {
            this.isLoading = false;
            if (this.onRemovedCallback && this.distributionList !== null) {
                this.onRemovedCallback(this.distributionList.id);
            }
        }).catch((error) => {
            this.log.error(`Deleting distribution list failed: ${error}`);
            this.isLoading = false;
        });
    }
    save() {
        switch (this.getMode()) {
            case "edit":
                return this.webClientService.modifyDistributionList(this.distributionList.id, this.members, this.name);
            case "new":
                return this.webClientService.createDistributionList(this.members, this.name);
            default:
                this.log.error('Cannot save distribution list, invalid mode');
                return Promise.reject('Cannot save distribution list, invalid mode');
        }
    }
    onChangeMembers(identities) {
        this.members = identities;
    }
    getMembers() {
        return this.members;
    }
}
